import create, { SetState } from "zustand";

import { THEME_CONFIGURATIONS } from "@shared-constants/theme";
import { SectionConfig, THEMES } from "@shared-types/themes";

export type ThemeStoreType = {
  theme: THEMES;
  setTheme: (theme: THEMES) => void;
  bodyBg: string;
  nav: SectionConfig;
  footerBg: string;
  fontFamily: string;
  animatedLPStyleSheets: string;
};

export const useThemeStore = create<ThemeStoreType>(
  (set: SetState<ThemeStoreType>) => ({
    theme: THEMES.DEFAULT,
    bodyBg: THEME_CONFIGURATIONS.DEFAULT.BODY_BG,
    nav: THEME_CONFIGURATIONS.DEFAULT.NAV,
    footerBg: THEME_CONFIGURATIONS.DEFAULT.FOOTER_BG,
    fontFamily: THEME_CONFIGURATIONS.DEFAULT.FONT_FAMILY,
    animatedLPStyleSheets: THEME_CONFIGURATIONS.DEFAULT.STYLE_SHEETS,
    setTheme: (theme: THEMES): void => {
      set((state) => {
        state.theme = theme;
        state.bodyBg = THEME_CONFIGURATIONS[theme].BODY_BG;
        state.nav = THEME_CONFIGURATIONS[theme].NAV;
        state.footerBg = THEME_CONFIGURATIONS[theme].FOOTER_BG;
        state.fontFamily = THEME_CONFIGURATIONS[theme].FONT_FAMILY;
        state.animatedLPStyleSheets = THEME_CONFIGURATIONS[theme].STYLE_SHEETS;
      });
    },
  })
);

export default useThemeStore;
